import { useEffect } from "react";

/**
 * Attaches a `beforeunload` handler while `isDirty` is true.
 * Browsers show their native "Leave site?" confirm; custom message text is
 * ignored by modern browsers but `returnValue` is required for legacy support.
 *
 * @param {boolean} isDirty
 */
export default function useUnsavedChangesWarning(isDirty) {
  useEffect(() => {
    if (!isDirty) return undefined;
    const handler = (event) => {
      event.preventDefault();
      event.returnValue = "";
      return "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [isDirty]);
}
